import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';

import './styles/App.css';
import './styles/custom.sass';
import 'react-toastify/dist/ReactToastify.css';

import Layout from "./components/Layout";
import Layout2 from "./components/Layout2";

import Home from "./pages/Home";
import Login from "./pages/Login";
import NoPage from "./pages/NoPage";
import Tickets from "./pages/Tickets";
import Profile from "./pages/Profile";
import SignUp from "./pages/SignUp";


import UserService from "./services/UserService";

function App() {

	return (
		<>
			<BrowserRouter>
				<Routes>
					<Route path="" element={<Home />} />
					<Route path="/login" element={<Login />} />
					<Route path="/signup" element={<SignUp />} />
					{ UserService.isAuthenticated() &&
						<Route path="/" element={<Layout />}>
							<Route path="tickets" element={<Tickets />} />
						</Route>
					}
					{ UserService.isAuthenticated() &&
						<Route path="/" element={<Layout2 />}>
							<Route path="profile" element={<Profile />} />
						</Route>
					}
					<Route path="*" element={<NoPage />} />
				</Routes>
			</BrowserRouter>
			<ToastContainer />
		</>
	);
}

export default App;
